import { useLocation, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { SEO } from "@/components/SEO";
import { findComparisonBySlug } from "@/data/comparisonsData";
import { buildComparisonSchema } from "@/data/advancedSchemas";
import { getRelatedContent } from "@/data/relatedContent";
import { GenericHero } from "@/components/content/Hero";
import { ComparisonBlock } from "@/components/content/Comparison";
import { SectionsBlock } from "@/components/content/Sections";
import { FaqBlock } from "@/components/content/Faq";
import { CtaBlock } from "@/components/content/Cta";
import { RelatedContentBlock } from "@/components/content/RelatedContent";

export default function ComparisonPage() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\/comparatifs\//, "");
  const comparison = findComparisonBySlug(slug);

  if (!comparison) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center px-4">
          <AlertCircle className="h-16 w-16 text-red-600 mx-auto mb-4" />
          <h1 className="text-3xl font-bold mb-4">Comparatif introuvable</h1>
          <Link to="/comparatifs">
            <Button>Voir tous les comparatifs</Button>
          </Link>
        </div>
      </div>
    );
  }

  const schema = buildComparisonSchema(comparison);
  const description = comparison.metaDescription;
  const keywords = `${comparison.keyword}, comparatif ${comparison.category}, ${comparison.title.toLowerCase()}, Mediastore Niort`;
  const breadcrumbs = [
    { name: "Accueil", path: "/" },
    { name: "Comparatifs", path: "/comparatifs" },
    { name: comparison.title, path: `/comparatifs/${comparison.slug}` },
  ];

  // Construire des relatedSlugs depuis l'intro (pas systématique, donc fallback ici)
  const fallbackRelated = [
    { ref: "reparation-iphone-niort", label: "Réparation iPhone Niort" },
    { ref: "reparation-mac-niort", label: "Réparation Mac Niort" },
  ];

  return (
    <div className="min-h-screen" data-testid="comparison-page">
      <SEO
        title={comparison.metaTitle}
        description={description}
        keywords={keywords}
        path={`/comparatifs/${comparison.slug}`}
        schema={schema}
        breadcrumbs={breadcrumbs}
        type="article"
        publishedTime={comparison.publishedDate}
        modifiedTime="2026-02-10"
      />

      <GenericHero
        category={comparison.category}
        badge="Comparatif"
        title={comparison.title}
        intro={comparison.intro}
        iconName={comparison.icon}
        accentColor="blue"
      />
      <ComparisonBlock comparison={comparison.comparison} />
      {comparison.sections && comparison.sections.length > 0 && <SectionsBlock sections={comparison.sections} />}
      <FaqBlock faqs={comparison.faqs} />
      <RelatedContentBlock items={getRelatedContent(comparison, "comparison")} />
      <CtaBlock relatedSlugs={comparison.relatedSlugs || fallbackRelated} />
    </div>
  );
}
